import { Check } from "lucide-react";
import Reveal from "./Reveal";

const PLANS = [
  {
    label: "Einrichtung",
    price: "990 €",
    unit: "einmalig",
    bullets: [
      "Komplettes System",
      "KI-Berater Einrichtung",
      "Funnel & CRM Setup",
      "Tracking & Integration",
    ],
  },
  {
    label: "Betreuung",
    price: "1.290 €",
    unit: "/ Monat",
    featured: true,
    bullets: [
      "Google Ads Management",
      "Funnel & KI-Optimierung",
      "KI-Berater & CRM",
      "Reporting & Analyse",
      "Support & Updates",
    ],
  },
  {
    label: "Laufzeit",
    price: "12",
    unit: "Monate",
    text: "Planbar. Transparent. Effizient.",
  },
];

export default function PricingSection({ onStart }) {
  return (
    <section className="border-b border-white/5 px-6 py-14 md:py-16" data-testid="pricing-section">
      <div className="mx-auto max-w-6xl">
        <Reveal>
          <p className="eyebrow mb-3">Preise</p>
          <h2 className="font-display text-3xl font-bold text-white md:text-4xl">
            Transparenter Preis – kein Kleingedrucktes.
          </h2>
        </Reveal>

        <div className="mt-10 grid gap-5 md:grid-cols-3">
          {PLANS.map((p, i) => (
            <Reveal key={p.label} delay={i * 0.1}>
              <div
                data-testid={`plan-${p.label.toLowerCase()}`}
                className={`flex h-full flex-col rounded-xl border p-7 ${
                  p.featured
                    ? "border-[#3DDC97]/50 bg-[#3DDC97]/[0.06] accent-glow"
                    : "border-white/10 bg-[#14161B]"
                }`}
              >
                {p.featured && (
                  <span className="mb-3 inline-block w-fit rounded-md bg-[#3DDC97] px-2.5 py-1 text-[11px] font-bold uppercase tracking-wider text-[#0c0d10]">
                    Beliebt
                  </span>
                )}
                <p className="text-sm font-semibold uppercase tracking-wider text-gray-400">
                  {p.label}
                </p>
                <div className="mt-3 flex items-end gap-2">
                  <span className="font-display text-5xl text-white">{p.price}</span>
                  <span className="mb-1.5 text-sm text-gray-400">{p.unit}</span>
                </div>

                {p.bullets && (
                  <ul className="mt-6 space-y-3">
                    {p.bullets.map((b) => (
                      <li key={b} className="flex items-start gap-2.5 text-[15px] text-gray-300">
                        <Check size={18} className="mt-0.5 shrink-0 text-[#3DDC97]" />
                        {b}
                      </li>
                    ))}
                  </ul>
                )}
                {p.text && (
                  <p className="mt-6 text-[15px] leading-relaxed text-gray-300">{p.text}</p>
                )}
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-10 flex flex-col items-start gap-4 sm:flex-row sm:items-center sm:justify-between">
            <div className="space-y-1 text-xs text-gray-500">
              <p>Alle Preise zzgl. gesetzl. USt.</p>
              <p>Angebot ausschließlich für Unternehmen (B2B).</p>
            </div>
            <button
              data-testid="pricing-cta"
              onClick={onStart}
              className="rounded-md bg-[#3DDC97] px-7 py-4 text-base font-semibold text-[#0E0F12] transition-colors hover:bg-[#2BBF7E]"
            >
              Jetzt starten
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
